import { defineNuxtRouteMiddleware } from "#app";
import {
  isInitialClientLoad,
  useHeadlessDataState,
} from "#imports";

export default defineNuxtRouteMiddleware( async ( _ ) => {
  // We don't want to call this on the initial client load as we're not calling
  // the headless middleware then either.
  // This was effectively nulling out the data during hydration on a headless route.
  if ( isInitialClientLoad() ) {
    return;
  }

  const headlessState = useHeadlessDataState();

  // We use this middleware to clean up the headless state for non-headless routes,
  // otherwise when we try to peek at this data it will be a stale reference

  headlessState.value = null;
} );
